module.exports = __webpack_public_path__ + "img/japan.cfedd85c.png";